<div class="ontario-row" [class.page-component]="isPageComponent">
  <button class="goback ng-star-inserted">
    @if (isPageComponent) {
      <img alt="Go back" src="assets/images/chevron-down-blue-border.svg"
        class="rotated back-arrow" (click)="backToMarketplace()">
    }
  </button>

  @if (classCourseWithEnrolmentsDTO.courseDetails) {
    <div [class.ontario-margin-top-48-!]="isPageComponent" class="page-content-with-right-sidebar">
      <div class="training-schedule-div main-content ontario-margin-bottom-24-!">
        @if (isPageComponent) {
          <div class="ontario-margin-bottom-24-!' action-buttons border-bottom ontario-padding-bottom-8-!" style="padding-left:0px !important">
            <h1>{{'ClassEnrolment.CourseEnrolmentRequest' | translate}}</h1>
          </div>
          <div class="ontario-column ontario-small-12 ontario-medium-10 ontario-large-10 ontario-margin-top-16-!">
            <app-alert-banner bannerType="warning" [bannerText]="translateService.instant('ClassEnrolment.WorkerEnrolmentNotConfirmed')">
            </app-alert-banner>
            <div class="alert-box-container ontario-margin-top-16-!">
              @if (enrolMentRequestType != 'ClassEnrolment.MultipleEnrolments') {
                <app-alert-banner bannerType="success"
                  [bannerText]="translateService.instant('ClassEnrolment.WorkerEnrolmentRequestSent').replace('{0}',classCourseWithEnrolmentsDTO.courseDetails!.ProgramFullName).replace('{1}',classCourseWithEnrolmentsDTO.courseDetails!.TrainingProviderName).replace('{2}',mainEmailAddress)">
                </app-alert-banner>
              }
              @if (enrolMentRequestType == 'ClassEnrolment.MultipleEnrolments') {
                <app-alert-banner bannerType="success"
                  [bannerText]="translateService.instant('ClassEnrolment.WorkerEnrolmentRequestSentPlural').replace('{0}',classCourseWithEnrolmentsDTO.courseDetails!.ProgramFullName).replace('{1}',classCourseWithEnrolmentsDTO.courseDetails!.TrainingProviderName).replace('{2}',mainEmailAddress)">
                </app-alert-banner>
              }
            </div>
          </div>
        }
        @if (updatedPending) {
          <div class="ontario-margin-bottom-24-!">
            <app-alert-banner bannerType="success" [bannerText]="'ClassEnrolment.EnrolmentRequestUpdated' | translate"></app-alert-banner>
          </div>
        }
        @if (updatedConfirmed) {
          <div class="ontario-margin-bottom-24-!">
            <app-alert-banner bannerType="success" [bannerText]="'ClassEnrolment.EnrolmentRequestUpdatedEnrolled' | translate"></app-alert-banner>
          </div>
        }
        @if (!isCompleted && isLearnersInfoInComplete()) {
          <div>
            <app-alert-banner bannerType="warning" [bannerText]="translateService.instant('ClassEnrolment.IncompleteLearner')"></app-alert-banner>
          </div>
        }
        @if (!isCompleted) {
          <div class="field ontario-column ontario-small-12 ontario-large-8" [class.ontario-margin-top-48-!]="isPageComponent">
            <mat-label class="input-label">
              <span>{{"ClassEnrolment.EnrolmentRequestType" | translate}}</span>
            </mat-label>
            <label class="answer-text">{{enrolMentRequestType | translate}}</label>
          </div>
        }
        @if (!isCompleted) {
          <div class="field ontario-column ontario-small-12 ontario-large-8">
            <mat-label class="input-label">
              <span>{{'ClassEnrolment.EnrolmentRequestFor' | translate}}</span>
            </mat-label>
            <label class="answer-text">{{enrolMentRequestFor | translate}}</label>
          </div>
        }
        @if ( !isTP && totalLearnersReserved > 1) {
          <div class="field  ontario-column ontario-small-12 ontario-large-8">
            @if (enrolMentRequestFor === 'ClassEnrolment.MyselfAndTeamMembers') {
              <div>
                {{'ClassEnrolment.SeatsIncludingYourself' | translate}}
              </div>
            }
            @if (enrolMentRequestFor === 'ClassEnrolment.TeamMembers') {
              <div>
                {{'ClassEnrolment.SeatsExcludingYourself' | translate}}
              </div>
            }
            <label class="answer-text">{{totalLearnersReserved}}</label>
          </div>
        }
        <!--Primary Contact Info-->
        @if (primaryContact && !(enrolMentRequestType ==='ClassEnrolment.SingleEnrolment' && enrolMentRequestFor ==='ClassEnrolment.Myself')) {
          <div class="ontario-margin-top-48-! ontario-small-12 ontario-column ontario-large-10 ontario-medium-10">
            <h2 class="border-bottom">{{'ClassEnrolment.PrimaryContact' | translate}}</h2>
            @if (isPageComponent) {
              <span class="answer-text">{{'ClassEnrolment.PleaseProvideYourContactDetails' | translate}}</span>
            }
          </div>
          <div class="field ontario-column ontario-small-12">
            <mat-label class="input-label blocked"><span>{{'ClassEnrolment.EmailAddress' | translate}}</span></mat-label>
            <mat-label class="answer-text">{{primaryContact.EmailAddress}}</mat-label>
          </div>
          <div class="field ontario-column ontario-small-12">
            <mat-label class="input-label blocked">
              <span>{{'Contact.FirstName' | translate}}</span>
            </mat-label>
            <mat-label class="answer-text">{{primaryContact.FirstName}}</mat-label>
          </div>
          <div class="field ontario-column ontario-small-12">
            <mat-label class="input-label blocked">
              <span>{{'Contact.LastName' | translate}}</span>
            </mat-label>
            <mat-label class="answer-text">{{primaryContact.LastName}}</mat-label>
          </div>
          <div class="field ontario-column ontario-small-12">
            <mat-label class="input-label blocked">
              <span>{{'ClassEnrolment.Phone' | translate}}</span>
            </mat-label>
            <mat-label class="answer-text">{{primaryContact.Phone | phone}}</mat-label>
          </div>
          <div class="field ontario-column ontario-small-12">
            <mat-label class="input-label blocked">
              <span>{{'ClassEnrolment.EmployeeName' | translate}}</span>
            </mat-label>
            <mat-label class="answer-text">{{primaryContact.EmployeeName | naIfEmpty}}</mat-label>
          </div>
          <div class="field ontario-column ontario-small-12">
            <div class="message-box">
              <mat-label class="input-label blocked">
                <span>{{'ClassEnrolment.Note' | translate}}</span>
              </mat-label>
              <div class="answer-text break-all">
                {{primaryContact.NoteToProvider | naIfEmpty}}
              </div>
            </div>
          </div>
          @if (!isPageComponent) {
            <div class="field ontario-column ontario-small-12">
              <div class="message-box">
                <mat-label class="input-label blocked">
                  <span>{{'ClassEnrolment.SubmittedOn' | translate}}</span>
                </mat-label>
                <div class="answer-text border-bottom-blue">
                  {{SubmittedDate | utcToLocalDateTime : 'medium'}}
                </div>
              </div>
            </div>
          }
        }
        <!--End Primary Contact Info-->
        <ng-container>
          <div class="ontario-column ontario-small-12" [class.ontario-margin-top-48-!]="!isCompleted">
            <h2 class="border-bottom">{{'ClassEnrolment.LearnerDetails' | translate}}</h2>
          </div>
          @if (!isPageComponent && !isCompleted) {
            <div class="ontario-margin-bottom-24-! ontario-column ontario-small-12 ontario-margin-top-8-!">
              <app-alert-banner bannerType="alert" [bannerText]="translateService.instant('ClassEnrolment.LearnerRecordPrivacy')"></app-alert-banner>
            </div>
          }
          @for (learner of Learners; track learner; let i = $index) {
            <div [class.box]="displaySelectLearnerCheckbox()" class="ontario-column ontario-small-12 ontario-large-10 ontario-medium-8 ontario-margin-bottom-8-! float-left"
              >
              @if (displaySelectLearnerCheckbox()) {
                <div>
                  <h3 class="ontario-margin-top-24-! ontario-padding-bottom-8-! ontario-margin-bottom-8-! border-bottom add-learner-header">
                    @if (isTP && learner.RegistrationId && learner.EnrolmentStatus == ENROLSTATUS.EnrolmentStatusPending) {
                      <app-checkbox class="app-checkbox" (checkedChange)="learnerSelectedOutput.emit(learner.RegistrationId)"></app-checkbox>
                    }
                    {{'ClassEnrolment.Learner' | translate}} {{i+1}} {{'ClassEnrolment.Details' | translate}}
                  </h3>
                </div>
              }
              @if (displaySelectLearnerCheckbox()) {
                <div>
                  {{'Contact.LearnerHasToProvidePersonalContactDetail' | translate}}
                </div>
              }
              <div class="field">
                <mat-label class="input-label">
                  <span [class.required-field]="i === 0 && enrolMentRequestType ==='ClassEnrolment.MultipleEnrolments' && enrolMentRequestFor ==='ClassEnrolment.Myself'">{{'ClassEnrolment.EmailAddress' | translate}}</span>
                </mat-label>
                <label class="answer-text">{{learner.EmailAddress | naIfEmpty}}</label>
              </div>
              <div class="field">
                <mat-label class="input-label">
                  <span [class.required-field]="i === 0 && enrolMentRequestType ==='ClassEnrolment.MultipleEnrolments' && enrolMentRequestFor ==='ClassEnrolment.Myself'">{{'Contact.FirstName' | translate}}</span>
                </mat-label>
                <label class="answer-text">{{learner.FirstName | naIfEmpty}}</label>
              </div>
              <div class="field">
                <mat-label class="input-label">
                  <span [class.required-field]="i === 0 && enrolMentRequestType ==='ClassEnrolment.MultipleEnrolments' && enrolMentRequestFor ==='ClassEnrolment.Myself'">{{'Contact.LastName' | translate}}</span>
                </mat-label>
                <label class="answer-text">{{learner.LastName | naIfEmpty}}</label>
              </div>
              <div class="field">
                <mat-label class="input-label">
                  <span [class.required-field]="i === 0 && enrolMentRequestType ==='ClassEnrolment.MultipleEnrolments' && enrolMentRequestFor ==='ClassEnrolment.Myself'">{{'ClassEnrolment.Phone' | translate}}</span>
                </mat-label>
                <label class="answer-text">{{learner.Phone | phone}}</label>
              </div>
              <div class="field">
                <mat-label class="input-label">
                  {{'ClassEnrolment.BirthYear' | translate}}
                </mat-label>
                <label class="answer-text">{{learner.BirthYear | naIfEmpty}}</label>
              </div>
              @if (enrolMentRequestFor === 'ClassEnrolment.Myself') {
                <div class="field">
                  <mat-label class="input-label">
                    <span>{{'ClassEnrolment.Note' | translate}}</span>
                  </mat-label>
                  <div class="answer-text message-box">{{learner.NoteToProvider | naIfEmpty}}</div>
                </div>
              }
              @if (learner && !isCompleted) {
                <div class="ontario-small-12">
                  <div class="heading">
                    <h3 class="border-bottom ontario-margin-bottom-24-! ontario-margin-top-32-!">
                      {{'TrainingEligibility.CourseEligibilityDetails' | translate}}
                    </h3>
                  </div>
                  <div class="elig-results" [class.more-up]="!(learner.Eligibility == undefined || learner.Eligibility == null)">
                    <div class="banner">
                      <div class="icon-div">
                        @if (learner.Eligibility) {
                          <div class="banner-circle" [ngClass]="learner.Eligibility ? 'success': 'failure'">
                            @if (learner.Eligibility) {
                              <img src="assets/images/checkmark-green.svg" alt="success" />
                            }
                            @if (!learner.Eligibility) {
                              <img src="assets/images/fail-cross-red.svg" alt="failure" />
                            }
                          </div>
                        }
                      </div>
                      <div class="icon-text">
                        @if (learner.Eligibility) {
                          <p
                            [innerHTML]='("TrainingEligibility.Results.EligibleForCourseShort" | translate).replace("{0}", currentLang == "en" ? classCourseWithEnrolmentsDTO.courseDetails.ProgramFullName : classCourseWithEnrolmentsDTO.courseDetails.ProgramFullNameFr)'>
                          </p>
                        }
                        @if (learner.Eligibility === false) {
                          <p
                            [innerHTML]='("TrainingEligibility.Results.NotEligibleForCourseShort" | translate).replace("{0}", currentLang == "en" ? classCourseWithEnrolmentsDTO.courseDetails.ProgramFullName : classCourseWithEnrolmentsDTO.courseDetails.ProgramFullNameFr)'>
                          </p>
                        }
                        @if (learner.Eligibility == undefined || learner.Eligibility == null) {
                          <p
                            [innerHTML]='("TrainingEligibility.Results.DetailsNotAvailable" | translate).replace("{0}", currentLang == "en" ? classCourseWithEnrolmentsDTO.courseDetails.ProgramFullName : classCourseWithEnrolmentsDTO.courseDetails.ProgramFullNameFr)'>
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (i ===0 && ((enrolMentRequestType === 'ClassEnrolment.SingleEnrolment' && enrolMentRequestFor === 'ClassEnrolment.Myself') || (enrolMentRequestType == 'ClassEnrolment.MultipleEnrolments' && enrolMentRequestFor == 'ClassEnrolment.Myself'))) {
                <div>
                  <div class="heading">
                    <h3 class="border-bottom ontario-margin-bottom-24-! ontario-margin-top-32-!">
                      {{'Contact.Subscription' | translate}}
                    </h3>
                  </div>
                  <div class="ontario-margin-bottom-12-!">
                    <div class="answer-text inline-block">
                      {{(learner.OptInForEmail === true ? 'General.Yes' : 'General.No') | translate }}
                    </div>
                    <div class="block-text">
                      {{'ClassEnrolment.OptInForEmail' | translate}}
                    </div>
                  </div>
                  <div class="ontario-margin-bottom-12-!">
                    <div class="answer-text inline-block">
                      {{(learner.OptInForText === true ? 'General.Yes' : 'General.No') | translate }}
                    </div>
                    <div class="block-text">
                      {{'ClassEnrolment.OptInForText' | translate}}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </ng-container>
        @if (isCompleted || isPageComponent || (enrolMentRequestType ==='ClassEnrolment.SingleEnrolment' && enrolMentRequestFor == 'ClassEnrolment.Myself')) {
          <div
            class="field ontario-column ontario-small-12 ontario-margin-bottom-48-! border-bottom">
            <mat-label class="input-label">
              {{(isCompleted ? 'ClassEnrolment.CourseCompletedOn' : 'ClassEnrolment.SubmittedOn') | translate}}
            </mat-label>
            @if (isCompleted) {
              <label class="answer-text">
                {{CompletedDate | utcToLocalDateTime : 'MMM dd, yyyy'}} {{'General.At' | translate}} {{CompletedDate | utcToLocalDateTime : 'hh:mm aa'}}
              </label>
            }
            @if (!isCompleted) {
              <label class="answer-text">
                {{SubmittedDate | utcToLocalDateTime : 'MMM dd, yyyy'}} {{'General.At' | translate}} {{SubmittedDate | utcToLocalDateTime : 'hh:mm aa'}}
              </label>
            }
          </div>
        }
        @if (isPageComponent) {
          <div class="action-buttons ontario-column hide-for-mobile ontario-column ontario-small-12 ontario-margin-bottom-24-! ontario-padding-left-0-!">
            <button class="grey-button" (click)="backToMarketplace()">
              {{'ClassEnrolment.BackToMarketplace' | translate}}
            </button>
          </div>
        }
      </div>
      <!--course details start -->
      @if (classCourseWithEnrolmentsDTO.courseDetails) {
        <div class="right-sidebar ">
          <div class="grey-box">
            <h3 class="border-bottom">{{'ClassEnrolment.CourseDetailsTitle' | translate}}</h3>
            <div class="review-row">
              <label class="question-text">{{'ClassEnrolment.ProgramName' | translate}}</label>
              <label class="answer-text"><b>{{currentLang == 'en' ? classCourseWithEnrolmentsDTO.courseDetails!.ProgramFullName : classCourseWithEnrolmentsDTO.courseDetails!.ProgramFullNameFr}}</b></label>
            </div>
            <div class="review-row">
              <label class="question-text">{{'ClassEnrolment.TrainingProvider' | translate}}</label>
              <label class="answer-text"><b>{{classCourseWithEnrolmentsDTO.courseDetails.TrainingProviderName}}</b></label>
            </div>
            @if (classCourseWithEnrolmentsDTO.courseDetails.AddressLine) {
              <div class="review-row">
                <label class="question-text">{{'ClassEnrolment.TrainingLocation' | translate}}</label>
                <label class="address-label"><b [innerHTML]="formatAddress()"></b></label>
              </div>
            }
            <div class="review-row">
              <label class="question-text">
                {{'ClassEnrolment.ClassInformation' | translate}}
              </label>
              @for (class of classCourseWithEnrolmentsDTO.courseDetails.ClassTimes; track class) {
                <label class="answer-text"
                  ><b>{{getDate((class.ClassDate | utcToLocalDateTime), 'MMM dd - EEE')}} &#64; {{getTime(class.StartDate)}} to {{getTime(class.EndDate)}}</b></label>
                }
                <label class="answer-text"><b>{{currentLang == 'en' ? classCourseWithEnrolmentsDTO.courseDetails.TrainingTypeName : classCourseWithEnrolmentsDTO.courseDetails.TrainingTypeNameFr}}</b></label>
              </div>
              <div class="review-row">
                <label class="question-text">{{'ClassEnrolment.SeatsAvailable' | translate}}</label>
                <label class="answer-text"><b>{{(classCourseWithEnrolmentsDTO.courseDetails.Capacity-classCourseWithEnrolmentsDTO.courseDetails.SeatsRegistered)}}/{{classCourseWithEnrolmentsDTO.courseDetails.Capacity}}</b></label>
              </div>
              <div class="review-row">
                <label class="question-text">
                  {{'ClassEnrolment.CourseFee' | translate}}
                </label>
                <label class="answer-text">
                  @if (classCourseWithEnrolmentsDTO.courseDetails.Cost) {
                    <b>{{classCourseWithEnrolmentsDTO.courseDetails.Cost | currency}}</b>
                  }
                  @if (!classCourseWithEnrolmentsDTO.courseDetails.Cost) {
                    <b>{{'CreateClassroom.ContactTrainingProviderForPricing' | translate }}</b>
                  }
                </label>
              </div>
              @if (classCourseWithEnrolmentsDTO.courseDetails.Email || classCourseWithEnrolmentsDTO.courseDetails.PhoneNumber || classCourseWithEnrolmentsDTO.courseDetails.Website) {
                <div class="review-row">
                  <label class="question-text">
                    {{'CreateNotification.Contact' | translate}}
                  </label>
                  <label class="answer-text">
                    @if (classCourseWithEnrolmentsDTO.courseDetails.Email) {
                      <b>{{classCourseWithEnrolmentsDTO.courseDetails.Email.ElectronicAddressValue}}</b>
                    }
                  </label>
                  <label class="answer-text">
                    @if (classCourseWithEnrolmentsDTO.courseDetails.PhoneNumber) {
                      <b>{{classCourseWithEnrolmentsDTO.courseDetails.PhoneNumber.ElectronicAddressValue | phone}}</b>
                    }
                  </label>
                  <label class="answer-text">
                    @if (classCourseWithEnrolmentsDTO.courseDetails.Website) {
                      <b>{{classCourseWithEnrolmentsDTO.courseDetails.Website.ElectronicAddressValue}}</b>
                    }
                  </label>
                </div>
              }
            </div>
          </div>
        }
        <!--end course details end-->
        <div class="border-bottom-thick ontario-margin-top-24-! hide-for-desk"></div>
        <div class="fixed-bottom">
          @if (isWorker) {
            <div class="menu-div menu-div-left">
              <a
              [routerLink]="this.currentLang == 'en'?'/worker/training-schedules':'/fr/worker/training-schedules'">{{this.translateService.instant('Worker.MySchedules')}}</a>
            </div>
          }
          <div class="menu-div menu-div-right">
            <a [routerLink]="getCPOApprovedCoursesURL()">{{this.translateService.instant('Worker.CpoApprovedCourse')}}</a>
          </div>
        </div>
      </div>
    }
  </div>
